export default __webpack_public_path__ + "static/media/utillities.dffc699f.svg";